
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_756_857)"}},[_c('path',{attrs:{"d":"M23 1H1v22h22V1z","fill":"#FFCD00"}}),_c('path',{attrs:{"d":"M10.275 13.96l4.434 5.394 1.308-1-3.758-4.483 3.25-4.048-1.323-.945-3.911 5.081zm-.606-9.316l-1.685.363v14.09H9.67V4.643z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_756_857"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1 1)","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    